import { postRequest } from '../../../shared/utils';

export async function getAllScreenGridAttributes(screenGridId: number, configSchema: string) {
  const body = {
    columns: ['value: screen_grid_attribute_id', 'label: attr_name'],
    screenGridId,
    schema: configSchema,
    table: 'v_screen_grid_attribute',
    key: 'screen_grid_id',
    value: screenGridId,
  };
  const { data, errors } = await postRequest('/api/records', body);
  if (errors) {
    return { errors };
  }

  return data;
}
